export default function Footer() {
  return (
    <div className="footer">
      <p>&copy; Socca Developers | All Rights Reserved</p>
    </div>
  );
}
